// import { NavBar } from "components/general/NavBar";
import Header from "components/general/Header";
import { Footer } from "components/general/FooterOld";
import AnnouncementsComponent from "components/Announcements/AnnouncementsComponent";
import { Row, Col, Container } from 'react-bootstrap';

export default function Announcements() {
  return (
    <>
      {/* <NavBar pagename="Announcements" /> */}
      <Header />
      <section className="meeting">
        <Container>
          <Row>
            <Col xs={12} >
              <AnnouncementsComponent />
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  )
}